import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

import { useAppSelector } from '../../../redux/hooks';
import useFetchMedicationConsistency from '../../../hooks/queries/useFetchMedicationConsistency';

import MedicationBox from './MedicationBox';

import { getCurrentWeekDatesAndRange } from '../../../utils/getCurrentWeekDatesAndRange';

import MESSAGES from '../../../constants/message';
import { IMedicationConsistency } from '../../../constants/types';

const MedicalTracker = () => {
  const navigate = useNavigate();
  const patientId = useAppSelector((state) => state.auth.currentUser?.id);
  const { medicationConsistency } = useFetchMedicationConsistency(patientId);

  const currentWeekRange = useMemo(() => getCurrentWeekDatesAndRange(), []);

  return (
    <Box className="d-flex flex-column flex-1" sx={{ background: '#F2F4F7' }}>
      <Box sx={{ pt: 8, px: 3, pb: 3 }} className="d-flex flex-column">
        <IconButton
          aria-label="back"
          sx={{ color: 'common.white', p: 0, mb: 4.5, alignSelf: 'start' }}
          onClick={() => navigate('/dashboard')}
        >
          <ArrowBack sx={{ fontSize: 40, color: 'text.primary' }} />
        </IconButton>
        <Typography variant="h4" sx={{ mb: 1 }}>
          {MESSAGES.MEDICATION.TRACKER.TITLE}
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.tertiary', mb: 5 }}>
          {MESSAGES.MEDICATION.TRACKER.DESCRIPTION}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {currentWeekRange}
        </Typography>
      </Box>
      {medicationConsistency &&
        medicationConsistency.map((medication: IMedicationConsistency) => (
          <MedicationBox
            key={medication.medication_id}
            medication={medication}
          />
        ))}
    </Box>
  );
};

export default MedicalTracker;
